import { Link } from "react-router-dom";
import { useGlobalDataList } from "../api";
import { GlobalExtractedClausesSection } from "../components/ExtractedClausesSection";
import { SettingsGroup } from "../components/SettingsGroup";
import { GlobalDriveConnectionCard } from "./GlobalDriveConnectionCard";
import { GlobalDriveFilesCard } from "./GlobalDriveFilesCard";
import { GlobalSlackChannelsCard } from "./GlobalSlackChannelsCard";
import styles from "./GlobalDataTab.module.css";

export const GlobalDataTab = () => {
  const list = useGlobalDataList();
  const records = list.data ?? [];
  const folders = records.filter((r) => r.kind === "drive_folder");

  return (
    <div className={styles.wrap}>
      <SettingsGroup title="Google Drive Sync">
        <GlobalDriveConnectionCard folders={folders} foldersLoading={list.isLoading} />
      </SettingsGroup>

      <SettingsGroup title="Files from Drive subscription">
        <GlobalDriveFilesCard folders={folders} />
      </SettingsGroup>

      <GlobalExtractedClausesSection />

      <SettingsGroup title="Slack channels">
        <GlobalSlackChannelsCard />
      </SettingsGroup>

      <p className={styles.historyLink}>
        <Link to="/global-data/history">Settings history</Link>
      </p>

    </div>
  );
};
